import React, { createContext, useContext, useMemo } from 'react';
import { useBreakpoint } from '@one-thd/sui-atomic-components';

interface CommonContextType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export const CommonContext = createContext<CommonContextType | undefined>(undefined);

export const CommonProvider = ({ children }: { children: React.ReactNode }) => {
  const isMobile: boolean = useBreakpoint('sm').lesser;
  const isTablet: boolean = useBreakpoint('md').exact;
  const isDesktop: boolean = useBreakpoint('lg').greater;

  const value = useMemo(
    () => ({ isMobile, isTablet, isDesktop }),
    [isMobile, isTablet, isDesktop]
  );

  return (
    <CommonContext.Provider value={value}>
      {children}
    </CommonContext.Provider>
  );
};

export default CommonProvider;

export const useCommonContext = () => {
  const context = useContext(CommonContext);
  if (context === undefined) {
    throw new Error('useCommonContext must be used inside CommonProvider');
  }
  return context;
};
